import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createStateSyncMiddleware } from 'redux-state-sync';
import thunk from 'redux-thunk';
import rootReducer from './rootReducers';

const reduxStateSyncConfig = { blacklist: ['persist/PERSIST'] };

const persistConfig = {
	key: 'fortress',
	storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false, // Disable serializable check for redux-persist
		}).concat(createStateSyncMiddleware(reduxStateSyncConfig), thunk),
	devTools: process.env.NODE_ENV === 'development', // Enable Redux DevTools in development mode
});

export const persistor = persistStore(store);

// Observer to get store outside React containers
export function toObservable(reduxStore) {
	return {
		subscribe({ onNext }) {
			let dispose = reduxStore.subscribe(() => onNext(reduxStore.getState()));
			onNext(reduxStore.getState());
			return { dispose };
		},
	};
}
